import { t } from 'i18next';
import * as yup from 'yup';

export const updateJobSchema = () =>
  yup.object().shape({
    status: yup.object().label(t('labelStatus')).nullable(),
    externalLocationRegion: yup.string().label(t('labelTheatre')).nullable(),
    externalLocationCountry: yup.object().label(t('labelExternalLocationCountry')).nullable(),
    customerNumber: yup.string().label(t('labelCustomerNumber')).nullable(),
    requestedByUser: yup.object().label(t('labelRequestedBy')).nullable(),
    requestedByUserEmployeeId: yup.string().label(t('labelRequestedByUserEmployeeId')).nullable(),
    supportUser: yup.object().label(t('labelSupportUser')).nullable(),
    supportCompletedDate: yup.string().label(t('labelSupportCompletedDate')).nullable(),
  });
